import { BrowserProvider, Contract, formatUnits, parseUnits } from "ethers";
import {
  useWeb3ModalProvider,
  useWeb3ModalAccount,
} from "@web3modal/ethers/react";

import Web3 from "web3";

import {
  TOKEN_CONTRACT_ADDRESS,
  PRESALE_CONTRACT_ADDRESS,
  USDT_CONTRACT_ADDRESS,
  USDC_CONTRACT_ADDRESS,
  TOKEN_ABI,
  PRESALE_ABI,
} from "../contracts/contracts";

const chain_id = 56;

function useContract() {
  const { walletProvider } = useWeb3ModalProvider();
  const { address, isConnected } = useWeb3ModalAccount();
  const getProvider = () => {
    return new BrowserProvider(walletProvider);
  };
  const getSigner = async (provider) => {
    return provider.getSigner();
  };

  const getContract = async (address, abi, signer) => {
    const contract = new Contract(address, abi, signer);
    return contract;
  };

  const buy = async (paymentType, amount) => {
    console.log("Payment Type:", paymentType, "Amount:");


    const provider = getProvider();
    const signer = await getSigner(provider);
    // print singer address
    const contract = await getContract(
      PRESALE_CONTRACT_ADDRESS,
      PRESALE_ABI,
      signer
    );
  

    if (paymentType === "BNB") {
      console.log("BNB");
      const transaction = await contract.buyFromNative( 
        {
          value: parseUnits(amount.toString(), 18),     
        }
      );
      const receipt = await transaction.wait();
      return receipt;
    } else if (paymentType === "USDT") {
      const usdc = await getContract(USDT_CONTRACT_ADDRESS, TOKEN_ABI, signer);
      const transaction = await usdc.approve(
        PRESALE_CONTRACT_ADDRESS,
        parseUnits(amount.toString(), 18)
      );
      await transaction.wait();

      const trx2 = await contract.buyFromToken( 
        // buying from token
        1,
       
        parseUnits(amount.toString(), 18)
      );
      await trx2.wait();
    } else if (paymentType === "USDC") {
      const usdc = await getContract(USDC_CONTRACT_ADDRESS, TOKEN_ABI, signer);
      const transaction = await usdc.approve(
        PRESALE_CONTRACT_ADDRESS,
        parseUnits(amount.toString(), 18)
      );
      await transaction.wait();

      const trx2 = await contract.buyFromToken( 
        // buying from token
        2,
       
        parseUnits(amount.toString(), 18)
      );
      await trx2.wait();
    }
  };

  const getData = async () => {
    // console.log(address);
    let token;
    if (!isConnected) {
      return;
      const web3 = new Web3(
        "https://bsc-mainnet.infura.io/v3/0128d6f4a7974e9c931c76b7dd439f87"
      );
      token = new web3.eth.Contract(TOKEN_ABI, TOKEN_CONTRACT_ADDRESS);
    } else {
      const provider = getProvider();
      // check chain id and throw error if not correct
      const chainId = await provider.getNetwork();
      // base chain id
      if (chainId.chainId != chain_id) {
        return;
      }

      const signer = await getSigner(provider);
      token = await getContract(TOKEN_CONTRACT_ADDRESS, TOKEN_ABI, signer);
    }

    const balance = await token.balanceOf(address);
    const balanceInEth = formatUnits(balance, 18);
    // console.log(balanceInEth);
    // contract token balance
    const contractBalanceInEth = await token.balanceOf(
      PRESALE_CONTRACT_ADDRESS
    );
    const contractBalance = formatUnits(contractBalanceInEth, 18);

    return {
      balanceInEth,
      contractBalance,
    };
  };

  const myTokenBalance = async () => {
    let token;
    if (!isConnected) {
      return 0;
    } else {
      const provider = getProvider();
      // check chain id and throw error if not correct
      const chainId = await provider.getNetwork();
      // base chain id
      if (chainId.chainId != chain_id) {
        return;
      }

      const signer = await getSigner(provider);
      token = await getContract(TOKEN_CONTRACT_ADDRESS, TOKEN_ABI, signer);
      const balance = await token.balanceOf(address);
      const balanceInEth = formatUnits(balance, 18);
      return balanceInEth;
    }
  };

  const maxBalances = async () => {
    let token;
    let token2;
    let usdcBalance;
    let usdtBalance;
    let ethbalance;
    if (!isConnected) {
      return {
        usdt: 0,
        busd: 0,
        eth: 0,
      };
    } else {
      const provider = getProvider();
      // check chain id and throw error if not correct
      const chainId = await provider.getNetwork();
      // base chain id
      if (chainId.chainId != chain_id) {
        return;
      }

      const signer = await getSigner(provider);
      token = await getContract(USDT_CONTRACT_ADDRESS, TOKEN_ABI, signer);
      token2 = await getContract(USDC_CONTRACT_ADDRESS, TOKEN_ABI, signer);
      usdtBalance = await token.balanceOf(address);

      usdcBalance = await token2.balanceOf(address);

      // eth balance
      ethbalance = await provider.getBalance(address);
    }

    return {
      usdt: Number(formatUnits(usdtBalance, 6)).toFixed(4),
      busd: Number(formatUnits(usdcBalance, 6)).toFixed(4),
      eth: Number(formatUnits(ethbalance, 18)).toFixed(4),
    };
  };




  

  const claimTokens = async () => {
    console.log(claimTokens);

    const provider = getProvider();
    const signer = await getSigner(provider);
    // print singer address
    const contract = await getContract(
      PRESALE_CONTRACT_ADDRESS,
      PRESALE_ABI,
      signer
    );
    const transaction = await contract.claimTokens(

   
    );
    const receipt = await transaction.wait();
    return receipt;
  };


  const claimAirdropTokens = async () => {
    console.log(claimAirdropTokens);

    const provider = getProvider();
    const signer = await getSigner(provider);
    // print singer address
    const contract = await getContract(
      PRESALE_CONTRACT_ADDRESS,
      PRESALE_ABI,
      signer
    );
    const transaction = await contract.claimAirdrop(

   
    );
    const receipt = await transaction.wait();
    return receipt;
  };

  const getPresaleAllocation = async () => {

    if (!isConnected) {
      return 0;
    } else {
      const provider = getProvider();
      // check chain id and throw error if not correct
      const chainId = await provider.getNetwork();
      // base chain id
      if (chainId.chainId != chain_id) {
        return;
      }

    const signer = await getSigner(provider);
    const contract = await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);

    console.log("Fetching unclaimed tokens for address:", address);






       // Call the getReferralReward function
       const [, , totalAmount] = await contract.getTotalUnclaimed(address);
       console.log("Raw totalAmount (BigNumber):", totalAmount);
   
       // Format the tokens using ethers.js formatUnits for 18 decimals
       const formattedUnclaimedTokens = formatUnits(totalAmount, 18);
       console.log("Formatted unclaimed tokens:", formattedUnclaimedTokens);
   
       // Reduce decimals to 2
       const airdropAmount = Number(formattedUnclaimedTokens).toFixed(0);
       console.log("Reduced unclaimed tokens (2 decimals):", airdropAmount);
   
       return airdropAmount;
  } 
};


const getAirdropAllocation = async () => {

  if (!isConnected) {
    return 0;
  } else {
    const provider = getProvider();
    // check chain id and throw error if not correct
    const chainId = await provider.getNetwork();
    // base chain id
    if (chainId.chainId != chain_id) {
      return;
    }

  const signer = await getSigner(provider);
  const contract = await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);

  console.log("Fetching unclaimed tokens for address:", address);



  
    // Call the getReferralReward function
    const unclaimedTokens = await contract.getAirdropUnclaimed(address);
    console.log("Raw unclaimed tokens (BigNumber):", unclaimedTokens);

    // Format the tokens using ethers.js formatUnits for 18 decimals
    const formattedUnclaimedTokens = formatUnits(unclaimedTokens, 18);
    console.log("Formatted unclaimed tokens:", formattedUnclaimedTokens);

    // Reduce decimals to 2
    const airdropAmount = Number(formattedUnclaimedTokens).toFixed(0);
    console.log("Reduced unclaimed tokens (2 decimals):", airdropAmount);

    return airdropAmount;
} 
};


const getreferAllocation = async () => {

  if (!isConnected) {
    return 0;
  } else {
    const provider = getProvider();
    // check chain id and throw error if not correct
    const chainId = await provider.getNetwork();
    // base chain id
    if (chainId.chainId != chain_id) {
      return;
    }

  const signer = await getSigner(provider);
  const contract = await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);

  console.log("Fetching unclaimed tokens for address:", address);

    // Call the getReferralReward function
    const unclaimedTokens = await contract.getReferralReward(address);
    console.log("Raw unclaimed tokens (BigNumber):", unclaimedTokens);

    // Format the tokens using ethers.js formatUnits for 18 decimals
    const formattedUnclaimedTokens = formatUnits(unclaimedTokens, 18);
    console.log("Formatted unclaimed tokens:", formattedUnclaimedTokens);

    // Reduce decimals to 2
    const referamount = Number(formattedUnclaimedTokens).toFixed(0);
    console.log("Reduced unclaimed tokens (2 decimals):", referamount);

    return referamount;
} 
};




const fetchTokenPrice = async () => {
  try {
    // Connect to the blockchain using a public provider
    const web3 = new Web3("https://bsc-mainnet.infura.io/v3/0128d6f4a7974e9c931c76b7dd439f87"); // Replace with your RPC URL

    // Instantiate the contract
    const contract = new web3.eth.Contract(PRESALE_ABI, PRESALE_CONTRACT_ADDRESS);

    // Fetch the perDollarPrice from the contract
    const rawPrice = await contract.methods.perDollarPrice().call();
    console.log("Raw perDollarPrice:", rawPrice);

    // Convert the price from BigNumber to human-readable format
    const decimals = 18; // Assuming 18 decimals
    const formattedPrice = rawPrice / Math.pow(10, decimals);

    return formattedPrice;
  } catch (err) {
    console.error("Error in fetchTokenPrice:", err.message || err);
    throw err; // Let the caller handle the error
  }
};





  const getPrice = async () => {
    console.log("Fetching price...");
    try {
      let contract;
      let price;
  
      if (!isConnected) {
        console.log("Not connected, using public Web3 provider...");
        const web3 = new Web3("https://bsc-mainnet.infura.io/v3/0128d6f4a7974e9c931c76b7dd439f87");
        contract = new web3.eth.Contract(PRESALE_ABI, PRESALE_CONTRACT_ADDRESS);
        price = await contract.methods.perDollarPrice().call();
        console.log("Price from public provider:", price);
      } else {
        console.log("Wallet connected, using signer...");
        const provider = getProvider();
        const chainId = await provider.getNetwork();
        if (chainId.chainId !== chain_id) {
          console.error("Incorrect chain ID!");
          return 0;
        }
  
        const signer = await getSigner(provider);
        contract = await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);
        price = await contract.perDollarPrice();
        console.log("Price from connected wallet:", price);
      }
  
      const formattedPrice = Number(formatUnits(price, 18)).toFixed(4);
      console.log("Formatted price:", formattedPrice);
      return formattedPrice;
    } catch (error) {
      console.error("Error in getPrice:", error);
      return 0; // Fallback value
    }
  };
  
  const getUserTokenBalance = async () => {
    if (!isConnected) {
      console.log("❌ User not connected");
      return "0";
    }
  
    try {
      console.log("🔍 Connecting to provider...");
      const provider = getProvider();
  
      // ✅ Get and log the detected Chain ID
      const network = await provider.getNetwork();
      console.log("🌐 Detected Chain ID:", network.chainId, "(Expected: 56)");
  
      if (Number(network.chainId) !== 56) {
        console.error("❌ Incorrect Chain ID! Expected 56, but got:", network.chainId);
        alert("Please switch to Binance Smart Chain (Chain ID: 56)");
        return "0";
      }
  
      const signer = await getSigner(provider);
      const contract = await getContract(PRESALE_CONTRACT_ADDRESS, PRESALE_ABI, signer);
  
      console.log("✅ Connected to contract, fetching balance for:", address);
  
      const userData = await contract.users(address);
      console.log("📊 Raw user data:", userData);
  
      if (!userData) {
        console.error("❌ No data returned from contract!");
        return "0";
      }
  
      // Convert and remove decimals
      const formattedBalance = Math.floor(Number(formatUnits(userData.token_balance, 18))); // No decimals
      console.log("✅ Formatted token balance:", formattedBalance);
  
      return formattedBalance;
    } catch (error) {
      console.error("❌ Error fetching user token balance:", error);
      return "0";
    }
  };
  
  
  return {
    buy,
    getData,
    myTokenBalance,
    maxBalances,
    getPrice,
    claimTokens,
    getPresaleAllocation,
    getAirdropAllocation,
    fetchTokenPrice,
    claimAirdropTokens,
    getreferAllocation,
    getUserTokenBalance
  };
}

export default useContract;
